import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';

export interface Step {
  number: number;
  title: string;
  active: boolean;
  completed: boolean;
  disabled: boolean;
}

@Component({
  selector: 'app-steps',
  imports: [CommonModule],
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
})
export class StepsComponent implements OnInit {
  @Input() steps: Step[] = [];
  @Input() stepChange!: EventEmitter<number>;

  @Output() onClickStep = new EventEmitter<Step>();

  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    if (this.stepChange) {
      this.stepChange.subscribe((stepNumber) => {
        const step = this.steps.filter((s) => s.number == stepNumber)[0];

        if (step != undefined) this.navigateToStep(step);
      });
    }
  }

  handleClickStep(step: Step) {
    this.navigateToStep(step);
    this.onClickStep.emit(step);
  }

  private navigateToStep(step: Step) {
    if (step.disabled) return;

    step.active = true;

    this.steps
      .filter((s) => s.number != step.number)
      .forEach((s) => {
        s.active = false;
      });

    this.cdr.detectChanges();
  }
}
